export class RealCurrentUser {
    private static userInstance: RealCurrentUser;

    private constructor() {

    }

    public static getInstance(): RealCurrentUser {
        if (typeof RealCurrentUser.userInstance === 'undefined') {
            RealCurrentUser.userInstance = new RealCurrentUser();
        }

        return RealCurrentUser.userInstance;
    }

    public getSuid() {
        return window.app.config.suid;
    }

    public getSig(): string {
        return window.app.config.sig;
    }
}
